import type {GridState, KeyboardEventModifiers} from '../types';
import {findFirst} from 'shared/utils/array-utils';
import {exists} from 'shared/utils/custom-utils';

export interface KeyBinding {
    matcher: KeyMatcher;
    handler: KeyHandler;
}

type KeyMatcher = (key: string, modifiers: KeyboardEventModifiers, state: GridState) => boolean;
type KeyHandler = (key: string, modifiers: KeyboardEventModifiers, state: GridState) => void;

export class KeyBindings {
    private bindings: KeyBinding[] = [];

    public addBinding(binding: KeyBinding) {
        this.bindings.push(binding);
        return this;
    }

    public hasKeyBinding(key: string, modifiers: KeyboardEventModifiers, state: GridState): boolean {
        return exists(this.findMatchingBinding(key, modifiers, state));
    }

    public handleKey(key: string, modifiers: KeyboardEventModifiers, state: GridState): void {
        const binding = this.findMatchingBinding(key, modifiers, state);
        if (exists(binding)) {
            binding.handler(key, modifiers, state);
        }
    }

    private findMatchingBinding(key: string, modifiers: KeyboardEventModifiers, state: GridState): KeyBinding | undefined{
        return findFirst(this.bindings, ({matcher}) => matcher(key, modifiers, state));
    }
}